import styled from 'styled-components'

import { style } from 'theme'

export const SuggestionWrapper = styled.div`
  position: relative;
  z-index: 2;
`

export const SuggestionsContainer = styled.div<{ shouldRenderContainer: boolean }>`
  ${props =>
    props.shouldRenderContainer &&
    `background-color: white;
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 15px 5px;
  max-height: 276px;
  overflow: auto;
  position: absolute;
  top: -26px;
  width: 100%;
  z-index: 3;

  > ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
`}
`

export const Suggestion = styled.div<{ highlighted: boolean }>`
  box-sizing: border-box;
  background-color: ${props =>
    props.highlighted ? style(theme => theme.colors.ivoryLight) : 'unset'};
  color: ${style(theme => theme.colors.slate)};
  cursor: pointer;
  font-size: 14px;
  letter-spacing: 0.5px;
  line-height: 22px;
  padding: 19px;
  position: relative;
  width: 100%;
  z-index: 2;

  &:disabled {
    opacity: 0.5;
  }
  &::placeholder {
    color: ${style(theme => theme.colors.ivory)};
  }
  &:focus {
    border-color: ${style(theme => theme.colors.ivoryLight)};
  }
`
